import { type KeyValueStorage, safeLocalStorage } from './utils.ts';

/**
 * Light/dark preference. branding/tokens.css follows the OS by default and honours
 * <html data-theme="light|dark"> as an explicit override — so "system" = no attribute.
 */
export type ThemePreference = 'system' | 'light' | 'dark';

export const THEME_STORAGE_KEY = 'bnb.theme';

export function readThemePreference(storage: KeyValueStorage = safeLocalStorage): ThemePreference {
  const value = storage.getItem(THEME_STORAGE_KEY);
  return value === 'light' || value === 'dark' ? value : 'system';
}

export function applyThemePreference(
  pref: ThemePreference,
  root: HTMLElement = document.documentElement,
): void {
  if (pref === 'system') delete root.dataset.theme;
  else root.dataset.theme = pref;
}

export function saveThemePreference(
  pref: ThemePreference,
  storage: KeyValueStorage = safeLocalStorage,
): void {
  if (pref === 'system') storage.removeItem(THEME_STORAGE_KEY);
  else storage.setItem(THEME_STORAGE_KEY, pref);
  applyThemePreference(pref);
}
